import {QRCodeSVG} from 'qrcode.react';
import {view} from '@sail/ui';
import {WalletConnectIcon} from 'src/v2/components/wallet/WalletConnectIcon';

const createWhiteImageBase64 = (size: number): string => {
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return '';
  }
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL('image/png');
};

const QR_CODE_SIZE = 266;
const EXCAVATE_AREA_SIZE = 64;

const whiteImageCache = new Map<number, string>();
const getWhiteImage = (size: number): string => {
  if (!whiteImageCache.has(size)) {
    whiteImageCache.set(size, createWhiteImageBase64(size));
  }
  return whiteImageCache.get(size)!;
};

interface QrCodeProps {
  qrCodeUri: string;
  iconUrl?: string;
  name?: string;
  size?: number;
  excavateSize?: number;
}

export const QrCode = ({
  qrCodeUri,
  iconUrl,
  name,
  size = QR_CODE_SIZE,
  excavateSize,
}: QrCodeProps) => {
  const showIcon = iconUrl && name;
  const shouldExcavate = showIcon || excavateSize;

  return (
    <view.div css={{stack: 'z'}}>
      <view.div>
        <QRCodeSVG
          value={qrCodeUri}
          size={size}
          level="H"
          marginSize={0}
          imageSettings={
            shouldExcavate
              ? {
                  src: getWhiteImage(excavateSize || EXCAVATE_AREA_SIZE),
                  height: excavateSize || EXCAVATE_AREA_SIZE,
                  width: excavateSize || EXCAVATE_AREA_SIZE,
                  excavate: true,
                }
              : undefined
          }
        />
      </view.div>
      {showIcon ? (
        <view.div
          css={{
            alignSelfX: 'center',
            alignSelfY: 'center',
          }}
        >
          <WalletConnectIcon
            iconUrl={iconUrl}
            name={name}
            width="44px"
            height="44px"
            borderRadius="large"
          />
        </view.div>
      ) : null}
    </view.div>
  );
};
